<script>
/* eslint-disable camelcase */
import errorHandler from '../AppFormAlert/errorHandler';

export default {
  name: 'AppList',
  components: {
    errorHandler,
  },

  props: {
    // 后端返回的列表数据
    list: {
      type: Object,
      default: () => ({}),
    },
    // 请求的接口
    api: {
      type: String,
      default: '',
    },
    // 请求的接口
    apiType: {
      type: String,
      default: '',
    },

    // 是否将请求条件放在url上
    exitUrl: {
      type: Boolean,
      default: true,
    },

    // 分页是否转接, 即不触发该组件的跳转
    transfer: {
      type: Function,
      default: null,
    },

    // 固定的请求条件
    fixedQuery: {
      type: String,
      default: '',
    },

    // 该列表页title
    title: {
      type: String,
      required: true,
    },

    // 添加按钮的文案
    createLabel: {
      type: [String, Boolean],
      default: false,
    },

    // 跳转页面按钮的文案
    skipLabel: {
      type: [String, Boolean],
      default: false,
    },
    // 下载按钮的文案
    downloadLabel: {
      type: [String, Boolean],
      default: false,
    },

    // excel按钮的文案
    excelLabel: {
      type: [String, Boolean],
      default: false,
    },
    // 下载加载
    excelLoading: {
      type: Boolean,
      default: false,
    },
    // 表格列字段筛选
    columns: {
      type: Array,
      default: () => {},
    },
    // 表格列字段筛选(已选中)
    columnsCheck: {
      type: Array,
      default: () => {},
    },
  },

  data() {
    return {
      // 控制页面加载状态
      loading: false,

      searchObj: {
        page: 1,
        per_page: 10,
      },

      checkList: this.columnsCheck ? this.columnsCheck.map(item => item.label) : undefined,
      schoolCenter: this.$store.state.from === 'schoolCenter',
      size: 'small',
      queryStr: '', // 请求参数
    };
  },
  // computed: {
  //   checkList() {
  //     return this.columnsCheck ? this.columnsCheck.map(item => item.label) : undefined;
  //   },
  // },
  watch: {
    columnsCheck() {
      this.checkList = this.columnsCheck ? this.columnsCheck.map(item => item.label) : undefined;
    },
  },
  created() {
    this.size = this.schoolCenter ? '' : 'small';

    if (!this.api) return;

    if (this.transfer) return;

    if (!this.exitUrl) {
      this.getData();

      return;
    }

    this.getList();

    this.$watch('$route.query', () => {
      this.getList();
    });
  },
  methods: {
    /**
     * 从url中获取参数，并依据参数获取列表数据
     */
    getList() {
      this.loading = true;

      let query = Object.keys(this.$route.query)
        .map(key => `${key}=${this.$route.query[key]}`)
        .join('&');

      if (this.fixedQuery) {
        query += `&${this.fixedQuery}`;
      }
      const url = this.apiType !== '' ? `${this.apiType}&${query}` : `${this.api}${/\?/.test(this.api) ? '&' : '?'}${query}`;
      this.queryStr = url;
      return this.$http.get(url)
        .then((data) => {
          const obj = Object.prototype.toString.call(data) === '[object Object]';
          if (obj) {
            this.$emit('update:list', data);
          } else {
            this.$emit('update:list', { items: data });
          }
        })
        .catch((error) => {
          this.$message.error(error.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getData() {
      this.loading = true;

      const query = Object.keys(this.searchObj)
        .map(key => `${key}=${this.searchObj[key]}`)
        .join('&');
      const url = this.apiType !== '' ? `${this.apiType}&${query}` : `${this.api}${/\?/.test(this.api) ? '&' : '?'}${query}`;
      this.queryStr = url;
      this.$http.get(url)
        .then((data) => {
          this.$emit('update:list', data);
        })
        .catch((error) => {
          this.$message.error(error.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * 改变每页条数
     * @param {number} per_page 每页条数
     */
    onSizeChange(per_page) {
      if (this.transfer) {
        this.transfer({
          per_page,
        });

        return;
      }

      if (!this.exitUrl) {
        this.searchObj = {
          page: 1,
          per_page,
        };

        this.getData();

        return;
      }

      this.$router.push({
        query: {
          ...this.$route.query,
          page: 1,
          per_page,
        },
      });
    },

    /**
     * 翻页
     * @param {number} page 当前页数
     */
    onCurrentChange(page) {
      if (this.transfer) {
        this.transfer({
          page,
        });

        return;
      }

      if (!this.exitUrl) {
        this.searchObj = {
          ...this.searchObj,
          page,
        };

        this.getData();

        return;
      }

      this.$router.push({
        query: {
          ...this.$route.query,
          page,
        },
      });
    },

    /**
     * 选择表格列筛选
     */
    checkedColumnsList(val) {
      this.$emit('checkedColumns', val);
    },
  },
};
</script>

<template>
  <div
    v-loading="loading"
    class="app-list"
  >
    <header class="list-header">
      <h2 class="list-header__title">{{ title }}</h2>
      <div class="list-header__filter">

        <!-- 自定义搜索 -->
        <slot
          name="search"/>

        <template v-if="columns && columns.length > 0">
          <!-- <div
            v-if="schoolCenter"
            class="columns-box-schoolCenter">
            <span>更多选项：</span>
            <el-checkbox-group
              v-model="checkList"
              @change="checkedColumnsList">
              <el-checkbox
                v-for="(item, index) in columns"
                v-if="!item.show"
                :disabled="item.disabled"
                :key="index"
                :label="item.label"/>
            </el-checkbox-group>
          </div> -->
          <el-popover
            class="columns_box_main"
            placement="left"
            width="500"
            trigger="hover">
            <div class="columns_box">
              <el-checkbox-group
                v-model="checkList"
                @change="checkedColumnsList">
                <el-checkbox
                  v-for="(item, index) in columns"
                  v-if="!item.show"
                  :disabled="item.disabled"
                  :key="index"
                  :label="item.label"/>
              </el-checkbox-group>
            </div>
            <span
              slot="reference"
              class="el-dropdown-link">
              更多选项<i class="el-icon-arrow-down el-icon--right"/>
            </span>
          </el-popover>
        </template>
        <el-button
          v-if="createLabel"
          :size="size"
          class="btn-float-right"
          type="primary"
          @click="$emit('create')"
        >
          {{ createLabel }}
        </el-button>

        <el-button
          v-if="skipLabel"
          :size="size"
          class="btn-float-right"
          type="primary"
          @click="$emit('skipPage')"
        >
          {{ skipLabel }}
        </el-button>

        <el-button
          v-if="excelLabel"
          :size="size"
          :loading="excelLoading"
          class="btn-float-right"
          type="primary"
          @click="$emit('excelPage', queryStr)"
        >
          {{ excelLabel }}
        </el-button>

        <el-button
          v-if="downloadLabel"
          :size="size"
          class="btn-float-right"
          type="primary"
          @click="$emit('downloadPage')"
        >
          {{ downloadLabel }}
        </el-button>
      </div>
    </header>

    <slot name="after"/>

    <div class="list-body">
      <slot :list-data="list.items" />
    </div>

    <footer
      v-if="schoolCenter"
      class="list-footer"
      style="padding-top: 1em; padding-bottom: 0;"
    >
      <el-pagination
        v-if="list.meta"
        :page-size="10"
        :current-page="list.meta.current_page"
        :total="list.meta.total"
        style="float: right;"
        background
        layout="prev, pager, next"
        @current-change="onCurrentChange"
      />
    </footer>
    <footer
      v-else
      class="list-footer"
    >
      <el-pagination
        v-if="list.meta"
        :current-page="list.meta.current_page"
        :page-sizes="[10, 20, 50, 100, 500]"
        :page-size="10"
        :total="list.meta.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="onSizeChange"
        @current-change="onCurrentChange"
      />
    </footer>
  </div>
</template>

<style lang="scss" scoped>
  .columns_box_main {
    display: inline-block;
  }
  .columns_box {
    .el-checkbox-group {
      display: flex;
      flex-wrap: wrap;
      .el-checkbox {
        flex: 0 0 33%;
        margin: 0 0 10px 0;
      }
    }
  }
  .el-dropdown-link {
    font-size: 14px;
    color: var(--color-primary);
  }
</style>
<style>
.app-list {
  display: flex;
  flex-direction: column;
}
.app-list .list-header {
  display: flex;
  align-items: center;
  padding: 1em 0;
}
.app-list .list-header__title {
  font-size: 1rem;
}
.app-list .list-header__filter {
  margin-left: auto;
}
.app-list .list-header__input {
  width: 280px;
  margin-left: 1em;
}
.app-list .list-footer {
  padding: 2em 0 1em;
  margin-top: auto;
}
</style>
<style scoped lang="scss">
  .school-center-theme {
    .list-header__filter {
      width: 100%;
      margin: 0;
    }
  }

  .columns-box-schoolCenter {
    & > span {
      float: left;
      color: #333436;
      font-size: 14px;
      line-height: 30px;
    }
    .el-checkbox-group {
      display: flex;
      flex-wrap: wrap;
    }
    .el-checkbox {
      line-height: 30px;
    }
  }

  .app-list {
    .list-header {
      padding-bottom: 16px;
    }
    /deep/ .search_box {
      margin: 0 24px 16px 0;
    }
    /deep/ .list-header__input {
      margin: 0;
    }
    /deep/ .app-search-index {
      .list-header__button {
        margin: 0;
      }
    }
  }
  .btn-float-right {
    float: right;
    margin-left: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppList/index.vue